export const FILTER_SEARCH_BUTTON_COLOR = "#2196F3";
export const FILTER_CLEAR_BUTTON_COLOR = "#F9F9F9";

export const PRIMARY_COLOR_BLUE = "#2196F3";

export const SUB_NOTE_GREAY = "#8D8D8D";